import React, { useRef } from "react";
import NavigationList from "./NavigationList";

const Navigation = () => {
    const menuItems = window.__SHARED__.Items || []; // ToDo we should really stop using this.
    // const viewAllProductsLink = window.__SHARED__.ViewAllProductsLink;
    const HomeLink = window.__SHARED__.HomeLink;

    return (
        <ul className="navbar-nav ms-lg-4 mx-1">
            {menuItems.map((menuItem, index) => (
                <NavigationList menuItem={menuItem} key={index} />
            ))}
        </ul>
    );
};

export default Navigation;
